const FakeClients = [
  {
    id: '5b56e70ab253020033364416',
    nom: 'Hassan',
    prenom: 'Idgar',
    address:'Huwan'
  },
  {
    id: '5b56e70ab25302003336442e',
    nom: 'Hillary',
    prenom: 'Yasser',
    address:'Tokyo'
  },
  {
    id: '5b56e70ab253020033364w93',
    nom: 'Kamir',
    prenom: 'Doary',
    address:'United State '
  },
  {
    id: '5b56e70ab2530200333648sh',
    nom: 'Iman',
    prenom: 'Abdtry',
    address:'12 Street Lost Angeles'
  },
  {
    id: '5b56e70ab25302003336441a0x',
    nom: 'Kamir',
    prenom: 'Bendazy',
    address:'Cotonou , Fidjrosè'
  },
  {
    id: '5b56e70ab2530200333649u7',
    nom: 'Kanan',
    prenom: 'Ilad',
    address:'Cocotomè Cotonou'
  },
  {
    id: '5b56e70ab253020033373gs5',
    nom: 'Ben',
    prenom: 'Harm',
    address:'Paris 12 Rue'
  },
  {
    id: '5b56e70ab533020033373gs5',
    nom: 'John',
    prenom: 'Hubbert',
    address:'New York , 12838 R'
  },
];

export default FakeClients;
